/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoApiRoleDeleteRequest model module.
 * @module model/SystemControllerDtoApiRoleDeleteRequest
 * @version 1.0
 */
class SystemControllerDtoApiRoleDeleteRequest {
    /**
     * Constructs a new <code>SystemControllerDtoApiRoleDeleteRequest</code>.
     * @alias module:model/SystemControllerDtoApiRoleDeleteRequest
     */
    constructor() { 
        
        SystemControllerDtoApiRoleDeleteRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoApiRoleDeleteRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoApiRoleDeleteRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoApiRoleDeleteRequest} The populated <code>SystemControllerDtoApiRoleDeleteRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoApiRoleDeleteRequest();

            if (data.hasOwnProperty('apiUrl')) {
                obj['apiUrl'] = ApiClient.convertToType(data['apiUrl'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoApiRoleDeleteRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoApiRoleDeleteRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['apiUrl'] && !(typeof data['apiUrl'] === 'string' || data['apiUrl'] instanceof String)) {
            throw new Error("Expected the field `apiUrl` to be a primitive type in the JSON string but got " + data['apiUrl']);
        }

        return true;
    }


}



/**
 * @member {String} apiUrl
 */
SystemControllerDtoApiRoleDeleteRequest.prototype['apiUrl'] = undefined;






export default SystemControllerDtoApiRoleDeleteRequest;

